export enum EProductionPlanType {
  NEW = "N",
  HOLD = "H",
  IN_PROGRESS = "I",
  PACKAGED = "P",
  DESTROYING = "D",
  COMPLETED = "C",
}
